var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"data-app":"true"}},[_c('companyProfileWrap',{attrs:{"user":_vm.user,"company_page":_vm.$route.params.id ? _vm.other_company : _vm.company_info}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }